import { render, staticRenderFns } from "./AwardList.vue?vue&type=template&id=1af27a06&scoped=true"
import script from "./AwardList.vue?vue&type=script&lang=js"
export * from "./AwardList.vue?vue&type=script&lang=js"
import style0 from "./AwardList.vue?vue&type=style&index=0&id=1af27a06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af27a06",
  null
  
)

export default component.exports